(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-maker-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-maker-reviews')) {
    customElements.define('sb-maker-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sbmr__track');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.prev = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.count = this.querySelector('[data-review-count]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelectorAll('[data-open-review]').forEach(button => { button.hidden = false; });
        const controls = this.querySelector('.sbmr__controls');
        if (controls) controls.hidden = false;
        this.addEventListener('click', event => {
          const open = event.target.closest('[data-open-review]');
          const close = event.target.closest('[data-close-review]');
          if (open) {
            const dialog = document.getElementById(open.dataset.openReview);
            if (dialog && this.contains(dialog)) dialog.showModal();
          }
          if (close) close.closest('dialog').close();
          if (event.target instanceof HTMLDialogElement) {
            const bounds = event.target.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
          }
          if (event.target.closest('[data-review-prev]')) this.move(-1);
          if (event.target.closest('[data-review-next]')) this.move(1);
        }, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(), 120);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-review-card]');
          if (card) this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (this.track.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        if (!this.prev || !this.next || !this.cards.length) return;
        const bounds = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ bounds: card.getBoundingClientRect(), index })).filter(card => card.bounds.left >= bounds.left - 8 && card.bounds.right <= bounds.right + 8);
        const first = visible.length ? visible[0].index + 1 : 1;
        const last = visible.length ? visible[visible.length - 1].index + 1 : first;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        this.count.textContent = this.count.dataset.countTemplate.replace('[current]', first === last ? String(first) : `${first}–${last}`).replace('[total]', String(this.cards.length));
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        clearTimeout(this.scrollTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starbond-cart-addons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('starbond-cart-addons')) {
    class StarbondCartAddons extends HTMLElement {
      connectedCallback() {
        this.onSubmit = this.onSubmit.bind(this);
        this.onCartUpdate = () => {
          if (this.busy || this.uncertain) return;
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 100);
        };
        this.onPageShow = (event) => {
          if (event.persisted) this.reloadCart();
        };
        this.addEventListener('submit', this.onSubmit);
        document.addEventListener('cart:updated', this.onCartUpdate);
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        this.removeEventListener('submit', this.onSubmit);
        document.removeEventListener('cart:updated', this.onCartUpdate);
        window.removeEventListener('pageshow', this.onPageShow);
        clearTimeout(this.refreshTimer);
        this.refreshController?.abort();
      }

      cartUrl() {
        const url = new URL(this.dataset.cartUrl, window.location.origin);
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url;
      }

      showError(message, reload = false) {
        const feedback = this.querySelector('.sbca-feedback');
        if (!feedback) return;
        feedback.querySelector('[data-addon-message]').textContent = message;
        const link = feedback.querySelector('[data-addon-reload]');
        link.href = this.cartUrl().href;
        link.hidden = !reload;
        feedback.hidden = false;
        feedback.focus();
      }

      async refresh() {
        if (this.busy || this.uncertain || !this.isConnected) return;
        this.refreshController?.abort();
        const controller = new AbortController();
        this.refreshController = controller;
        const url = this.cartUrl();
        url.searchParams.set('section_id', this.dataset.sectionId);
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = html.querySelector('starbond-cart-addons [data-addon-content]');
          if (updated && !controller.signal.aborted && !this.busy && this.isConnected) {
            this.querySelectorAll('product-slider').forEach((slider) => slider.destroySlider?.());
            this.querySelector('[data-addon-content]').innerHTML = updated.innerHTML;
          }
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.refreshFailed = 'true';
        }
      }

      reloadCart() { window.location.reload(); }

      navigateToCart() { window.location.assign(this.cartUrl().href); }

      async onSubmit(event) {
        const form = event.target;
        if (!form.matches('.sbca-form')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || this.uncertain) return;
        const cartItemsClass = customElements.get('cart-items');
        if (cartItemsClass?.updating || document.querySelector('cart-items[aria-busy="true"]')) {
          this.showError(this.dataset.pending);
          return;
        }
        const variantId = Number(new FormData(form).get('id'));
        if (!Number.isSafeInteger(variantId) || variantId <= 0) {
          this.showError(this.dataset.error);
          return;
        }
        this.busy = true;
        this.refreshController?.abort();
        clearTimeout(this.refreshTimer);
        if (cartItemsClass) cartItemsClass.updating = true;
        const controls = [...document.querySelectorAll('starbond-cart-addons button, starbond-cart-addons select, main-cart button, main-cart input, main-cart select, main-cart textarea')].filter((control) => !control.disabled);
        controls.forEach((control) => { control.disabled = true; });
        const express = [...document.querySelectorAll('main-cart .additional-checkout-buttons')].filter((element) => !element.inert);
        express.forEach((element) => { element.inert = true; });
        this.setAttribute('aria-busy', 'true');
        this.querySelector('.sbca-feedback').hidden = true;
        const button = form.querySelector('button');
        const buttonText = button.querySelector('[data-addon-button-text]') || button;
        const label = buttonText.textContent;
        buttonText.textContent = this.dataset.adding;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        let confirmed = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) {
            if (response.status >= 400 && response.status < 500) {
              this.showError(typeof result.description === 'string' ? result.description : this.dataset.error);
              return;
            }
            throw new Error('Unconfirmed add');
          }
          if (!result.items?.some((item) => Number(item.variant_id ?? item.id) === variantId && item.quantity > 0)) {
            throw new Error('Invalid add response');
          }
          confirmed = true;
          this.navigateToCart();
        } catch (error) {
          this.uncertain = true;
          this.showError(this.dataset.uncertain, true);
        } finally {
          clearTimeout(timeout);
          if (!confirmed) {
            controls.forEach((control) => {
              if (control.isConnected && !(this.uncertain && control.closest('starbond-cart-addons'))) control.disabled = false;
            });
            express.forEach((element) => { if (element.isConnected) element.inert = false; });
            if (cartItemsClass) cartItemsClass.updating = false;
            buttonText.textContent = label;
            this.busy = false;
            this.removeAttribute('aria-busy');
          }
        }
      }
    }
    customElements.define('starbond-cart-addons', StarbondCartAddons);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storelocator"] && !Shopify.designMode) return;
  try {
    
(function () {
  const defaults = {
    count_one: '1 dealer',
    count_many: '__COUNT__ dealers',
    matching_one: '1 dealer found',
    matching_many: '__COUNT__ dealers found',
    loading: 'Loading dealers…',
    selected: 'View map',
    view_map: 'View map',
    directions: 'Get directions',
    call: 'Call',
    email: 'Email',
    website: 'Website',
    map_title_empty: 'Find your local Starbond dealer',
    map_address_empty: 'Select a dealer to see its location.',
    no_matches_map: 'Try a nearby city, another ZIP code, or a dealer name.',
    error: 'The dealer directory could not load. Please try again.',
    map_frame_title: 'Starbond dealer map',
    untitled_dealer: 'Starbond dealer',
    show_more: 'Show more dealers',
    visible_summary: 'Showing __SHOWN__ of __COUNT__'
  };
  const fields = ['location_title', 'location_address', 'location_number', 'location_email', 'location_website', 'location_map_link'];
  const pageSize = 20;

  function normalize(value) {
    return value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/œ/g, 'oe').replace(/ß/g, 'ss').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }

  function initialize(root) {
    if (root.dataset.locatorInitialized === 'true') return;
    root.dataset.locatorInitialized = 'true';
    const find = (selector) => root.querySelector(selector);
    const search = find('[data-locator-search]');
    const clear = find('[data-clear-search]');
    const list = find('[data-dealer-list]');
    const status = find('[data-result-status]');
    const networkCount = find('[data-network-count]');
    const emptyState = find('[data-empty-state]');
    const errorState = find('[data-error-state]');
    const frame = find('[data-map-frame]');
    const placeholder = find('[data-map-placeholder]');
    const mapTitle = find('[data-map-title]');
    const mapAddress = find('[data-map-address]');
    const mapDirections = find('[data-map-directions]');
    const mapPanel = find('[data-map-panel]');
    const loadMore = find('[data-load-more]');
    const visibleSummary = find('[data-visible-summary]');
    const viewButtons = Array.from(root.querySelectorAll('button[data-view]'));
    if (!search || !list || !status || !frame) return;
    let translations = {};
    const translationScript = find('script[data-locator-i18n]');
    if (translationScript) {
      try {
        const parsed = JSON.parse(translationScript.textContent);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) translations = parsed;
      } catch (error) {
        translations = {};
      }
    }
    const t = (key, values = {}) => {
      let text = typeof translations[key] === 'string' && translations[key] ? translations[key] : defaults[key] || '';
      Object.keys(values).forEach((name) => {
        text = text.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), String(values[name]));
        text = text.split('__' + name.toUpperCase() + '__').join(String(values[name]));
      });
      return text;
    };
    let records = [];
    let matches = [];
    let selected = null;
    let visibleLimit = pageSize;
    let state = 'loading';
    let inputTimer;
    let controller;
    let generation = 0;
    let displayedCards = new Map();

    function value(record, key) {
      return typeof record[key] === 'string' ? record[key].trim() : '';
    }

    function dealerTitle(item) {
      return value(item.record, 'location_title') || t('untitled_dealer');
    }

    function dealerQuery(item) {
      return [value(item.record, 'location_title'), value(item.record, 'location_address')].filter(Boolean).join(', ');
    }

    function directionsUrl(item) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dealerQuery(item));
    }

    function embedUrl(item) {
      const raw = value(item.record, 'location_map_link');
      if (raw) {
        try {
          const url = new URL(raw);
          const trustedHost = ['google.com', 'www.google.com', 'maps.google.com'].includes(url.hostname.toLowerCase());
          const embedPath = /^\/maps\/embed(?:\/|$)/.test(url.pathname) || /^\/maps\/d\/.*\/embed\/?$/.test(url.pathname);
          const embedQuery = /^\/maps\/?$/.test(url.pathname) && url.searchParams.get('output') === 'embed';
          if (url.protocol === 'https:' && trustedHost && !url.username && !url.password && !url.port && (embedPath || embedQuery)) return url.href;
        } catch (error) {
          return 'https://maps.google.com/maps?q=' + encodeURIComponent(dealerQuery(item)) + '&output=embed';
        }
      }
      return 'https://maps.google.com/maps?q=' + encodeURIComponent(dealerQuery(item)) + '&output=embed';
    }

    function websiteUrl(raw) {
      if (!raw) return '';
      try {
        const url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(raw) ? raw : 'https://' + raw);
        return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
      } catch (error) {
        return '';
      }
    }

    function setView(view) {
      root.dataset.view = view === 'map' ? 'map' : 'list';
      viewButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.view === root.dataset.view)));
    }

    function showBlankMap(message) {
      frame.hidden = true;
      frame.removeAttribute('src');
      if (placeholder) {
        placeholder.hidden = false;
        placeholder.textContent = message || t('map_address_empty');
      }
      if (mapTitle) mapTitle.textContent = t('map_title_empty');
      if (mapAddress) mapAddress.textContent = t('map_address_empty');
      if (mapDirections) {
        mapDirections.hidden = true;
        mapDirections.removeAttribute('href');
      }
    }

    function updateSelection() {
      displayedCards.forEach((nodes, item) => {
        const active = item === selected;
        nodes.card.classList.toggle('is-selected', active);
        nodes.button.setAttribute('aria-pressed', String(active));
        nodes.button.textContent = t(active ? 'selected' : 'view_map');
        nodes.button.setAttribute('aria-label', t(active ? 'selected' : 'view_map') + ': ' + dealerTitle(item));
      });
      if (!selected) {
        showBlankMap(state === 'ready' ? t('no_matches_map') : t(state === 'error' ? 'error' : 'loading'));
        return;
      }
      if (mapTitle) mapTitle.textContent = dealerTitle(selected);
      if (mapAddress) mapAddress.textContent = value(selected.record, 'location_address');
      if (mapDirections) {
        mapDirections.href = directionsUrl(selected);
        mapDirections.textContent = t('directions');
        mapDirections.setAttribute('aria-label', t('directions') + ': ' + dealerTitle(selected));
        mapDirections.hidden = false;
      }
      if (placeholder) placeholder.hidden = true;
      frame.title = t('map_frame_title') + ': ' + dealerTitle(selected);
      frame.hidden = false;
      const url = embedUrl(selected);
      if (frame.getAttribute('src') !== url) frame.src = url;
    }

    function selectDealer(item, explicit) {
      selected = item;
      updateSelection();
      if (explicit && window.matchMedia('(max-width: 899px)').matches) {
        setView('map');
        if (mapTitle) mapTitle.focus({ preventScroll: true });
        if (mapPanel) mapPanel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function link(text, href, label, external) {
      const anchor = document.createElement('a');
      anchor.className = 'sb-locator-card__contact';
      anchor.textContent = text;
      anchor.href = href;
      if (label) anchor.setAttribute('aria-label', label);
      if (external) {
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
      }
      return anchor;
    }

    function createCard(item) {
      const card = document.createElement('article');
      card.className = 'sb-locator-card';
      card.setAttribute('role', 'listitem');
      const title = document.createElement('h3');
      title.className = 'sb-locator-card__title';
      title.textContent = dealerTitle(item);
      card.appendChild(title);
      const address = value(item.record, 'location_address');
      if (address) {
        const text = document.createElement('p');
        text.className = 'sb-locator-card__address';
        text.textContent = address;
        card.appendChild(text);
      }
      const contacts = document.createElement('div');
      contacts.className = 'sb-locator-card__contacts';
      const footer = document.createElement('div');
      footer.className = 'sb-locator-card__footer';
      const phone = value(item.record, 'location_number');
      const phoneTarget = phone.replace(/[^\d+*#,;]/g, '');
      if (/\d/.test(phoneTarget)) contacts.appendChild(link(phone, 'tel:' + phoneTarget, t('call') + ' ' + dealerTitle(item) + ': ' + phone));
      const email = value(item.record, 'location_email');
      if (/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email)) contacts.appendChild(link(t('email'), 'mailto:' + encodeURIComponent(email).replace('%40', '@'), t('email') + ' ' + dealerTitle(item)));
      const website = websiteUrl(value(item.record, 'location_website'));
      if (website) contacts.appendChild(link(t('website'), website, t('website') + ': ' + dealerTitle(item), true));
      if (contacts.childNodes.length) footer.appendChild(contacts);
      const actions = document.createElement('div');
      actions.className = 'sb-locator-card__actions';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sb-locator-card__map';
      button.addEventListener('click', () => selectDealer(item, true));
      actions.appendChild(button);
      const directions = link(t('directions'), directionsUrl(item), t('directions') + ': ' + dealerTitle(item), true);
      directions.className = 'sb-locator-card__directions';
      actions.appendChild(directions);
      footer.appendChild(actions);
      card.appendChild(footer);
      displayedCards.set(item, { card, button });
      return card;
    }

    function renderCards() {
      const fragment = document.createDocumentFragment();
      displayedCards = new Map();
      matches.slice(0, visibleLimit).forEach((item) => fragment.appendChild(createCard(item)));
      list.replaceChildren(fragment);
      const shown = Math.min(visibleLimit, matches.length);
      if (visibleSummary) {
        visibleSummary.hidden = matches.length === 0;
        visibleSummary.textContent = t('visible_summary', { shown, count: matches.length });
      }
      if (loadMore) {
        loadMore.hidden = shown >= matches.length;
        loadMore.textContent = t('show_more');
      }
      updateSelection();
    }

    function filterRecords() {
      if (clear) clear.hidden = search.value.length === 0;
      if (state !== 'ready') return;
      const query = normalize(search.value);
      const tokens = query.split(' ').filter(Boolean);
      matches = tokens.length ? records.filter((item) => tokens.every((token) => item.search.includes(token) || item.searchCompact.includes(token))) : records.slice();
      visibleLimit = pageSize;
      if (!matches.slice(0, visibleLimit).includes(selected)) selected = matches[0] || null;
      if (emptyState) emptyState.hidden = matches.length > 0;
      if (errorState) errorState.hidden = true;
      status.textContent = t(query ? (matches.length === 1 ? 'matching_one' : 'matching_many') : (matches.length === 1 ? 'count_one' : 'count_many'), { count: matches.length });
      renderCards();
    }

    function resetSearch() {
      window.clearTimeout(inputTimer);
      search.value = '';
      setView('list');
      filterRecords();
      search.focus();
    }

    async function loadDirectory() {
      const currentGeneration = ++generation;
      if (controller) controller.abort();
      controller = new AbortController();
      const currentController = controller;
      const timeout = window.setTimeout(() => currentController.abort(), 12000);
      state = 'loading';
      records = [];
      matches = [];
      selected = null;
      displayedCards.clear();
      list.replaceChildren();
      list.setAttribute('aria-busy', 'true');
      root.dataset.loading = 'true';
      status.textContent = t('loading');
      if (networkCount) networkCount.textContent = '—';
      if (emptyState) emptyState.hidden = true;
      if (errorState) errorState.hidden = true;
      if (loadMore) loadMore.hidden = true;
      if (visibleSummary) visibleSummary.hidden = true;
      showBlankMap(t('loading'));
      try {
        const response = await fetch(root.dataset.directoryUrl, { signal: currentController.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('Directory request failed');
        const data = await response.json();
        if (!data || !Array.isArray(data.locations)) throw new Error('Invalid dealer directory');
        const parsed = data.locations.map((record, index) => {
          if (!record || typeof record !== 'object' || Array.isArray(record) || fields.some((key) => key in record && typeof record[key] !== 'string')) throw new Error('Invalid dealer record');
          if (!value(record, 'location_title') && !value(record, 'location_address')) throw new Error('Dealer location is missing');
          const searchText = normalize([value(record, 'location_title'), value(record, 'location_address')].join(' '));
          return { record, index, search: searchText, searchCompact: searchText.replace(/\s+/g, '') };
        });
        parsed.sort((a, b) => dealerTitle(a).localeCompare(dealerTitle(b), undefined, { sensitivity: 'base', numeric: true }) || a.index - b.index);
        if (currentGeneration !== generation) return;
        records = parsed;
        state = 'ready';
        if (networkCount) networkCount.textContent = String(records.length);
        list.setAttribute('aria-busy', 'false');
        root.dataset.loading = 'false';
        filterRecords();
      } catch (error) {
        if (currentGeneration !== generation) return;
        state = 'error';
        list.setAttribute('aria-busy', 'false');
        root.dataset.loading = 'false';
        status.textContent = t('error');
        if (errorState) errorState.hidden = false;
        if (emptyState) emptyState.hidden = true;
        showBlankMap(t('error'));
      } finally {
        window.clearTimeout(timeout);
      }
    }

    search.addEventListener('input', () => {
      window.clearTimeout(inputTimer);
      if (clear) clear.hidden = search.value.length === 0;
      setView('list');
      inputTimer = window.setTimeout(filterRecords, 100);
    });
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        window.clearTimeout(inputTimer);
        filterRecords();
      }
      if (event.key === 'Escape' && search.value) {
        event.preventDefault();
        resetSearch();
      }
    });
    if (clear) clear.addEventListener('click', resetSearch);
    root.querySelectorAll('[data-reset-search]').forEach((button) => button.addEventListener('click', resetSearch));
    root.querySelectorAll('[data-retry]').forEach((button) => button.addEventListener('click', () => {
      search.focus();
      loadDirectory();
    }));
    viewButtons.forEach((button) => button.addEventListener('click', () => setView(button.dataset.view)));
    if (loadMore) loadMore.addEventListener('click', () => {
      const firstNewItem = matches[Math.min(visibleLimit, matches.length)];
      visibleLimit += pageSize;
      renderCards();
      const firstNewCard = displayedCards.get(firstNewItem);
      if (firstNewCard) firstNewCard.button.focus();
    });
    setView(root.dataset.view || 'list');
    if (clear) clear.hidden = search.value.length === 0;
    frame.loading = 'lazy';
    loadDirectory();
  }

  function initializeAll(container) {
    if (container.matches && container.matches('[data-store-locator]')) initialize(container);
    container.querySelectorAll('[data-store-locator]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
